import type { FunctionComponent } from "react";
import { t } from "i18next";

import { StyledIcon, StyledWrapper } from "./style";
import { Icon, Text } from "@smartsuite/react-ui/lib";
import { GrayColors } from "@smartsuite/types";

export const NoRecords: FunctionComponent = () => {
  return (
    <StyledWrapper>
      <StyledIcon>
        <Icon name="history" color={GrayColors["G-5"]} />
      </StyledIcon>
      <Text>{t("automation-activity.no-records-message")}</Text>
    </StyledWrapper>
  );
};
